// ============================================================
// useFeeStructureItems Hooks
// ============================================================

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { feeStructureItemService } from '@/services/feeStructureItemService';

export function useFeeStructureItems(feeStructureId) {
  return useQuery({
    queryKey: ['feeStructureItems', feeStructureId],
    queryFn: () => feeStructureItemService.getItems(feeStructureId),
    enabled: !!feeStructureId,
  });
}

export function useCreateFeeStructureItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ feeStructureId, payload }) =>
      feeStructureItemService.createItem(feeStructureId, payload),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feeStructureItems', variables.feeStructureId] });
    },
  });
}

export function useUpdateFeeStructureItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, feeStructureId, payload }) =>
      feeStructureItemService.updateItem(itemId, payload),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feeStructureItems', variables.feeStructureId] });
    },
  });
}

export function useDeleteFeeStructureItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, feeStructureId }) =>
      feeStructureItemService.deleteItem(itemId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feeStructureItems', variables.feeStructureId] });
    },
  });
}
